import { DEFAULT_COUNTRY, INITIAL_FORM_DATA } from "../constants/constants";

export const getInitialFormData = (initialDetails) => {
  const initialFormData = Object.keys(INITIAL_FORM_DATA).reduce(
    (obj, key) => ({ ...obj, [key]: { ...INITIAL_FORM_DATA[key] } }),
    {},
  );
  if (initialDetails) {
    const { fullName, mobileNumber, country, companyName, companyEmail } = initialDetails;

    initialFormData.fullName.value = fullName ?? "";
    initialFormData.mobileNumber.value = mobileNumber ?? "";
    initialFormData.country.value = country ?? "";
    initialFormData.companyName.value = companyName ?? "";
    initialFormData.companyEmail.value = companyEmail ?? "";
  } else {
    initialFormData.country.value = DEFAULT_COUNTRY;
  }
  return initialFormData;
};

export const getFormDataValues = (formData) => {
  const { fullName, mobileNumber, country, companyName, companyEmail } = formData;
  return {
    fullName: fullName.value.trim(),
    mobileNumber: mobileNumber.value.trim(),
    country: country.value,
    companyName: companyName.value.trim(),
    companyEmail: companyEmail.value.trim(),
  };
};

export const generateSubmitRequestPayload = (formData, LeadProduct, LineOfBusiness, pageUrl, utmParams) => {
  const { fullName, mobileNumber, country, companyName, companyEmail } = getFormDataValues(formData);
  const { utm_medium, utm_source, utm_campaign } = utmParams;
  const payload = {
    body: {
      SiebelMessage: {
        IntObjectName: "CreateLead",
        ListOfCreateLead: {
          Lead: {
            AlternatePhone: mobileNumber,
            Category: "Cold",
            Description: pageUrl,
            EmailAddress: companyEmail,
            FirstName: fullName,
            LastName: "",
            LeadStatus: "Open",
            UtmMedium: utm_medium,
            UtmSource: utm_source,
            UtmCampaign: utm_campaign,
            LeadProduct: LeadProduct,
            LeadSegment: `${country.phone == "91" ? "SMB" : "Global"}`,
            ProductInterest: "",
            LeadLOB: "",
            OrganizationName: companyName,
            Source: "TALK_TO_EXPERT",
            CountryCode: `+${country.phone}`,
            ListOfLeadLineItems: {
              LeadLineItems: {
                AddressLine1: "",
                AddressLine2: "",
                CircleName: "",
                CityName: "",
                LineOfBusiness: LineOfBusiness,
                PinCode: "",
                ProductId: "",
                ProductMarketName: "",
                ProductPrice: "",
                ServicePlanName: "",
                State: "",
                Country: country.name,
              },
            },
          },
        },
      },
    },
  };
  return payload;
};
